import './dashboard.scss';
import Boards from "components/dashboard/boards";
import useNavigate, { Link } from 'react-router-dom';
import Tickets from "components/dashboard/tickets";
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { actions } from 'redux/reducers';

function Dashboard({
    isArchivedItems
}: {
    isArchivedItems: boolean,
}) {
    const dispatch = useDispatch();

    if (window.location.href.indexOf('/archived') > -1) {
        isArchivedItems = true;
    }

    useEffect(() => {
        dispatch(actions.board.set(null));
        dispatch(actions.columns.set([]));
    }, [dispatch])

    return (
        <div id="dashboard">
             <Link to={`/clients`} title={"Back to client list"}>
                <div className="back-button">Back to clients</div>
            </Link>

            <Tickets />
            <Boards isArchivedItems={isArchivedItems} />
        </div>
    )
}

export default Dashboard;